//
// # Schematic Rules Validation (SRV) namespace
//
// Only the wire types remain in TypeScript: the rule engine now runs on the
// Rust tool server (`crates/schematic-srv/`). These types describe the result
// shape the server returns and the IDE renders.
//

export * from "./types";
